import * as types from "../types/dispactherNote.types";

const initialState = {
  dispactherNoteData: [],
};

const DispactherNoteReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_DISPACTHER_NOTES_LIST_DATA:
      return { ...state, dispactherNoteData: action.payload };
    case types.RESET_ZONE_REDUCER:
      return { 
        ...state, 
        dispactherNoteData: [],
      };
    default:
      return state;
  }
};
export default DispactherNoteReducer;
